import { CUSTOMER_REVIEW_DATA } from 'constants/signup';
import useGlobalStore from 'hooks/useGlobalStore';

export default function CustomerReviews() {
    const { isMisfitsTheme } = useGlobalStore();

    return (
        <section className="w-full bg-lime if:bg-strawberry">
            <div className="mx-auto max-w-[790px]">
                <h1 className="text-body-lg py-30 pl-30 font-grotesk-bold md:text-center">
                    Don&apos;t just take our word for it
                </h1>
                <div className="flex flex-row justify-between overflow-scroll px-20 pb-30 lg:overflow-visible lg:px-0">
                    {CUSTOMER_REVIEW_DATA.map((review) => (
                        <div
                            key={review.mmImage}
                            className="mx-10 h-fit min-w-[240px] max-w-[240px] rounded-lg bg-white"
                        >
                            <img
                                width={240}
                                height={isMisfitsTheme ? review.mmHeight : review.ifHeight}
                                className="w-full rounded-t-lg"
                                alt="Shop on mobile"
                                src={isMisfitsTheme ? review.mmImage : review.ifImage}
                            />
                            <p className="px-20 pb-10 pt-20">{isMisfitsTheme ? review.mmCopy : review.ifCopy}</p>
                            <p className="px-20 pb-20 font-grotesk-bold">
                                {isMisfitsTheme ? review.mmSocialHandle : review.ifSocialHandle}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
